import moment from 'moment';
import mapValues from 'lodash/mapValues'

// define functions here that enrich data returned by the backend
// optimally, all functions here should eventually be deleted

export const createSimpleRule = (ruleName, permit, divisionId, value) => {
  return {
    permit_id: permit.id,
    division_id: divisionId,
    name: ruleName,
    operation: "None",
    start_date: moment().utc().clone().subtract(365, 'days'),
    end_date: moment().utc().clone().add(365, 'days'),
    target: "None",
    type: -1,
    value
  };
};

export const transformPermit = (originalPermit) => {
  if (!originalPermit) {
    return {};
  }

  const permit = Object.assign({}, originalPermit);
  if (permit.divisions) {
    Object.keys(permit.divisions).forEach((divisionId) => {
      permit.divisions[divisionId].isStartingPoint = true;
      permit.divisions[divisionId].childDivisions = [];
    });
  }
  return permit;
};

export function convertAddressToLegacyFormat(addresses) {
  if (Array.isArray(addresses)) {
    return addresses.map((address) => {
      return {
        ...address,
        street_address1: address.address1,
        street_address2: address.address2,
        state_code: address.state,
        postal_code: address.zip_code
      }
    })
  }
  return addresses
}

// @param p  permit
// @param pc permitcontent
export const loadContentIntoPermit = (p, pc) => {
  const permit = {
    ...p, // don't need to cloneDeep if replacing 1 level deep
    description: pc.description,
    important_dates: pc.important_dates,
    latitude: pc.latitude,
    longitude: pc.longitude,
    addresses: convertAddressToLegacyFormat(pc.addresses),
    phone: pc.phone,
    links: pc.links,

    // maps only description_map of pc.divisions onto p.divisions
    divisions: mapValues(p.divisions, (v, k) => (
      {
        ...v,
        description_map: pc.divisions[k].description_map,
        description: pc.divisions[k].description
      }
    ))
  }

  return permit;
}
